export default __webpack_public_path__ + "static/media/webberConnectLogo.805fb5f0.png";